import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { getIP } from 'src/app/modules/jobseeker-registration/services/registration/jobseeker-registration.service';

@Injectable()
export class JobsService {

  api_url = environment.SERVER_URL + 'icrweb/home/';
  /*   api_url: string = "http://192.168.0.135:4284/api/";  */
  //api: string = "http://192.168.0.124:61693/api/";

  //api: string = "http://192.168.0.127:9008/api/";
  constructor(
    private http: HttpClient

  ) { }

  /*  getcomments(requirement_id) {
      return this.http.get(this.api_url + 'Comments/CommentDetails', { params: { lng_id: '1', tn_id: '1', req_id: requirement_id } });
    }   */

  getcomments(requirement_id) {
    return this.http.get(this.api_url + 'Comments/CommentDetail', { params: { lng_id: '1', req_id: requirement_id } });
  }
  savecomment(details) {
    return this.http.post(this.api_url + 'Comment/Data', details);
  }
  savelike(details) {
    return this.http.post(this.api_url + 'Like/Data', details, { params: { lng_id: '1', tn_id: '1' } });
  }
  getbookmark(details) {
    return this.http.post(this.api_url + 'bookmark', details, { params: { lng_id: '1', tn_id: '1' } });
  }
  savebookmark(details) {
    return this.http.post(this.api_url + 'save_job_to_favourites', details);
  }


  /*  getJobs() {
     return this.http.get(this.api_url + 'Resume/details', { params: { lng_id: '1' } });
   } */

  saveJobs(request, isAlert?) {
    if (isAlert) {
      return this.http.post(this.api_url + 'jobAlertList', request);
    }
    else {
      return this.http.post(this.api_url + 'tallite_career_portal_job_list', request);
    }
  }
  saveAppliedJobs(details, flag) {
    return this.http.post(this.api_url + 'Requisition/GetAppliedJobs', details, { params: { lng_id: '1', tn_id: '1', flag: flag } });
  }

  withdrawApi(obj) {
    return this.http.post(this.api_url + 'ReqResume/withdraw', obj);
  }

  getJobSearchMaster(request) {
    return this.http.post(this.api_url + 'tallite_career_portal_job_search_master', request, {
      headers: {
        header_type: '2'
      }
    })
  }

  applyForJob(request, header_type?) {
    return this.http.post(this.api_url + 'tallite_career_portal_apply_job', request, {
      headers: {
        header_type: header_type || '1'
      }
    })

  }
  getJobs(request) {
    return this.http.post(this.api_url + 'tallite_career_portal_job_detail', request);
  }
  getMasters(params?) {
    if (!params) {
      try {
        let ip_details = getIP()
        params = {}
        params['ip'] = ip_details['ip'];
        params['sellerShortCode'] = environment.SHORTCODE;
      }
      catch (err) {

      }
    }
    else {
      params['sellerShortCode'] = environment.SHORTCODE;
    }
    return this.http.get(environment.SERVER_URL + 'icrweb/countryMaster', { params: params, headers: { header_type: '2' } })
  }
}
